import {Locale} from 'date-fns';
import {enUS} from 'date-fns/locale/en-US';

export const DefaultLocale: Locale = enUS;

export const SUPPORTED_LOCALES = [
  'ar',
  'bg',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IN',
  'en-NZ',
  'en-US',
  'es',
  'fi',
  'fr',
  'fr-CA',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nb',
  'nl',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'th',
  'tr',
  'uk',
  'vi',
  'zh-CN',
  'zh-TW',
];

export function extractLanguageFromLocale(locale: string): string {
  const delimiterIndex = locale.indexOf('-', 2);
  if (delimiterIndex > 0) {
    return locale.substring(0, delimiterIndex);
  }
  return locale;
}
